// Load all the channels within this directory and all subdirectories.
// Channel files must be named *_channel.js.
//
// THIS DIRECTORY IS CURRENTLY INERT, AND THAT IS NOT OBVIOUS FROM READING IT (#60).
// `require.context` below matches only `*_channel.js`, and there are none — this directory holds
// exactly `index.js` and `consumer.js`. So `import "channels"` in `packs/application.js` loads
// nothing at all, and `consumer.js` is imported by nobody. It is stock
// `rails webpacker:install:actioncable` scaffolding that was never built on.
//
// Why the note is here rather than the files being deleted: this is the wiring you want back the
// moment a real channel is added, and it costs nothing to keep. But it was actively misleading —
// it answers "is ActionCable eagerly loaded?" with a confident *yes* to anyone who greps, and that
// wrong answer is precisely what made #59 hard to find: because nothing eagerly imported
// actioncable, it sat in no initial chunk, so turbo-rails' lazy `await import(...)` was its only
// consumer and fetched it over the network on every signed-in page.
//
// If you add a `foo_channel.js` here, it starts working with no further changes — but read the
// warning in `consumer.js` first, because importing it is not free.
const channels = require.context('.', true, /_channel\.js$/)
channels.keys().forEach(channels)
